
import Vue from "vue";

export default Vue.extend({
    name: "ModalPopup",
    props: {
        isOpen: Boolean,
        title: String,
        showClose: Boolean,         // set to false to hide the close "X" in the title header (non-slidein modal)
        isLarge: Boolean,           // is a large modal dialog (extra width, implements modal-lg
        customClass: String,
        closeTrigger: Boolean       // this is the trigger that commences the leave transition
    },
    computed: {
        computedTransition () {
            return 'fade';
        }
    },
    methods: {
        afterLeave() {
            this.$emit('modal-popup-close-complete');
        }
    }
});
